<template>
    <form ref="OKR_SLO_IF">
    </form>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
    created() {
        this.getOkrHostUrl();
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        getOkrHostUrl() {
            let obj = this;
            let reqData = {
                url : "/api/org/getCodeValueList",
                method : "post",
                params : {
                    cdCategory: 'config.okr',
                    cdKey: 'host.url'  
                }
            };
            this
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                let codeList = res.result;
                let okrHostUrl = codeList[0].cdValue;
                obj.createOkrSlo(okrHostUrl);
            })
            .catch(function(err) {
                console.log(err);
            });
        },       
        createOkrSlo(okrHostUrl) {
            let obj = this;
            let reqData = {
                url : "/api/auth/slo/reverseSlo",
                method : "post",
            };
            this
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.result !== null) {
                    let slo_p_ota = res.result;
                    // okrparam : /neo/branch/common/slo/loginOKR.mvc?destination=services/okr/home/ohT1M02Popup.mvc|okrType=CO|okrId=86646|qrtCd=20204Q" 의 URL Encoding 값
                    okrHostUrl = okrHostUrl + decodeURIComponent(obj.$route.query.okrparam);
                    okrHostUrl = okrHostUrl + "&slo_p_ota=" + slo_p_ota;
                    obj.$refs.OKR_SLO_IF.method = 'POST';
                    obj.$refs.OKR_SLO_IF.action = okrHostUrl;
                    obj.$refs.OKR_SLO_IF.submit();
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/slo/GoCircleOkr.vue